export const addQueryParam = (history, location, baseUrl, key, value) => {
  const params = new URLSearchParams(location.search);
  params.set(key, value);
  history.replace(`${baseUrl}?${params.toString()}`);
};

export const removeQueryParam = (history, location, baseUrl, key) => {
  const params = new URLSearchParams(location.search);
  params.delete(key);
  const search = params.toString();
  history.replace(`${baseUrl}${search ? `?${search}` : ''}`);
};
